import { connect } from "react-redux"
import { itemPreviewType } from "../../calendarView"
import ItemDragLayer from "../components/ItemDragLayer.react"

export default connect((state) => ({
  itemPreviewType: itemPreviewType(state),
}))(ItemDragLayer)
